// Elements/PageTabsViewModal.jsx

import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

function PageTabsViewModal({ pageTabsIconsOnlyCurrent, savePrefrenceCallback, setHomeData }) {
  const { register, setValue, watch } = useFormContext();

  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (pageTabsIconsOnlyCurrent) {
      setSelected(2); // Icon Only
      setValue("PageTabsView", true);
    } else {
      setSelected(1); // Icon and Name
      setValue("PageTabsView", false);
    }
  }, [pageTabsIconsOnlyCurrent, setValue]);

  const handleSelected = (option) => {
    setSelected(option);
    const iconsOnly = option === 2;
    setValue("PageTabsView", iconsOnly);

    setTimeout(() => {
      const updated = { ...watch(), PageTabsView: iconsOnly };
      savePrefrenceCallback(updated);
      setHomeData(updated);
    }, 0);
  };

  return (
    <>
      <div className="d-flex align-items-center justify-content-evenly" style={{ gap: "0px" }}>
        <div
          className={"d-flex align-items-center gap-1 height-35 "}
          onClick={() => handleSelected(1)}
        >
          <input
            type="radio"
            {...register("PageTabsView")}
            className="radio-input"
            checked={selected === 1}
            readOnly
          />
          <div className={`radio-circle ${selected === 1 ? "checked" : ""}`} />
          <span>Icon and Name</span>
        </div>

        <div
          className={"d-flex align-items-center gap-1 height-35 "}
          onClick={() => handleSelected(2)}
        >
          <input type="radio" className="radio-input" checked={selected === 2} readOnly />
          <div className={`radio-circle ${selected === 2 ? "checked" : ""}`} />
          <span>Icon Only</span>
        </div>
      </div>
    </>
  );
}

export default PageTabsViewModal;
